import styled from 'styled-components';
import {textSizes} from '@stencil/build-theme/src/build-theme';

export const FilterCheckboxItem = styled.div<{$wrapperStyles?: any}>`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  &.active {
    color: #2276e3;
    background: #e5f3ff;
    border: 1px solid #2276e3;
    ${textSizes.SmallW2};
  }

  input {
  }

  label {
  }
  padding: 1.6rem;
  ${props => props?.$wrapperStyles || {}};
`;

export const FilterInput = styled.input<{$width?: string; $height?: string; $arrowWidth?: string}>`
  /* Hide the default checkbox */
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  width: ${props => props.$width || '20px'};
  height: ${props => props.$height || '20px'};
  border: 2px solid grey;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  /* Hover effect */
  &:hover {
    border-color: #2276e3;
    box-shadow: 0 0 4px rgba(34, 118, 227, 0.5);
  }

  /* Checked state */
  &:checked {
    background-color: #2276e3;
    border-color: transparent;
  }

  /* Checkmark animation */
  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${props => props.$arrowWidth || '35%'};
    height: ${props => (props.$arrowWidth ? `calc(2 * ${props.$arrowWidth})` : '70%')};
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -60%) rotate(45deg);
    transition:
      transform 0.2s ease,
      opacity 0.2s ease;
  }

  /* Add a bounce animation on check */
  &:checked::after {
    animation: bounce 0.3s ease;
  }

  @keyframes bounce {
    0%,
    100% {
      transform: translate(-50%, -60%) rotate(45deg) scale(1);
    }
    50% {
      transform: translate(-50%, -60%) rotate(45deg) scale(1.2);
    }
  }
`;

export const FilterLabel = styled.label<{$labelStyles?: any}>`
  align-items: center;
  display: flex;
  gap: 0.8rem;
  ${textSizes.BaseW1};
  color: #222;
  position: relative;
  cursor: pointer;
  padding: 0;
  ${props => props?.$labelStyles || {}};
`;
